export default __webpack_public_path__ + "static/media/mechatron.a3674370.pdf";